import React from "react";
import { Card } from "antd";
import { renderer } from "../../helpers/";

const renderBlockV2MCQ = (block: any) => {
    const {
        data: { other: { description = [] } = {} },
    } = block;

    return (
        <div>
            <Card>{renderer(description)}</Card>
        </div>
    );
};
export default renderBlockV2MCQ;
